<div class="wrapper">
	@if (titleTemplate) {
		<h1 class="filter-divider">
			<ng-template [ngTemplateOutlet]="titleTemplate" [ngTemplateOutletContext]="{ $implicit: options[0]?.title }" />
		</h1>
	} @else {
		<h1 class="filter-divider">{{ options[0]?.title }}</h1>
	}
	@if (options) {
		<ul class="filter-list">
			@for (option of options; track option) {
				<li [class.active]="isSelected(option)" (focusClick)="selectOption(option)">
					@if (optionTemplate) {
						<ng-template [ngTemplateOutlet]="optionTemplate" [ngTemplateOutletContext]="{ $implicit: option }" />
					} @else {
						{{ option }}
					}
				</li>
			}
		</ul>
	}
</div>

@if (children.length > 0) {
	<ng-container [formGroup]="innerForm">
		<ic-blade-input formControlName="child" [options]="children" [parent]="parent">
			@if (titleTemplate) {
				<ng-template #titleTmpl let-title>
					<ng-template [ngTemplateOutlet]="titleTemplate" [ngTemplateOutletContext]="{ $implicit: title }" />
				</ng-template>
			}
			@if (optionTemplate) {
				<ng-template #optionTmpl let-option>
					<ng-template [ngTemplateOutlet]="optionTemplate" [ngTemplateOutletContext]="{ $implicit: option }" />
				</ng-template>
			}
		</ic-blade-input>
	</ng-container>
}
